import { stashSessionDataAndInitialData } from './sessionDataResponseStash';
import { getInitialMailData } from './getInitialMailData';
import { SessionData } from 'owa-service/lib/types/SessionData';

export async function stashSessionDataResponses(sessionData: SessionData) {
    const initialMailData = await getInitialMailData(sessionData);
    stashSessionDataAndInitialData(sessionData, initialMailData);
}
